import ApiService from "@/common/api.service"

export const CpdProviderReportService = {
    getCpdProviderReports() {
        return ApiService.get("/cpdProviderReport")
    },
    getCpdProviderReportsWP(query) {
        let queryParam = `/cpdProviderReport${query}`;
        return ApiService.get(queryParam);
    },

}